import React, { PureComponent } from 'react'
import { css } from 'emotion'
import { PageHeader } from 'components'
import { bamboobg } from 'images'

class Container extends PureComponent {
  render() {
    const { children, className } = this.props
    const classNames = css(className, styles.container)
    return (
      <section className={classNames}>
        <PageHeader />
        {children}
      </section>
    )
  }
}

const styles = {
  container: css({
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    background: `url(${bamboobg})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
  }),
}

export default Container
